import { Injectable } from '@angular/core';
import { DataService } from '../session/index';

@Injectable()
export class CommonCboService {
  constructor(private dataService: DataService) { }
  private listarTipoDocumentoCboUrl: string = 'parametro/controles/ListarTipoDocumentoCbo';

  listarTipoDocumentoCbo(): any {
    this.dataService.set(this.listarTipoDocumentoCboUrl);
    return this.dataService.execGetJson();
  }

}
